var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-wrapper"},[_c('img',{staticClass:"empty-icon",attrs:{"src":require("@/assets/common/empty.png"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.$t('dashboard.noData')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-536cd3d0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseEmptyView.vue
// module id = null
// module chunks = 